import { iconNames } from 'lucide-react/dynamic';

const iconNameSet = new Set(iconNames);

function kebabToLabel(kebab) {
  return kebab
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

/**
 * All Lucide icons (kebab-case keys), sorted alphabetically by display label.
 */
export const LUCIDE_SERVICE_ICON_OPTIONS = [...iconNames]
  .map((value) => ({ value, label: kebabToLabel(value) }))
  .sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
  );

/**
 * Maps stored keys to Lucide dynamic icon names (kebab-case).
 * Supports legacy camelCase values saved before the full icon list (e.g. shieldCheck → shield-check).
 */
export function normalizeServiceIconKey(key) {
  if (key == null || String(key).trim() === '') return 'briefcase';
  const s = String(key).trim();

  if (s.includes('-')) {
    const lower = s.toLowerCase();
    return iconNameSet.has(lower) ? lower : 'briefcase';
  }

  const kebab = s
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();

  if (iconNameSet.has(kebab)) return kebab;
  const lower = s.toLowerCase();
  if (iconNameSet.has(lower)) return lower;

  return 'briefcase';
}
